export const jsonValidator = (str: string): boolean => {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        console.error("json validator error");
        return false;
    }
};